import { captionClassNames, labelClassNames } from './stripeWrapperClassNames';

interface StripeElementWrapperProps {
  children: React.ReactNode;
  error: string;
  name: string;
  label: string;
}
// TODO: Using other Stripe elements should be explored
// TODO: Otherwise, using InputField from @prenuvo/halo with as={StripeElement}
export const StripeElementWrapper: React.FC<StripeElementWrapperProps> = ({
  children,
  error,
  name,
  label,
}) => {
  return (
    <div className="relative">
      {children}
      <label className={labelClassNames} data-testid={name}>
        {label}
      </label>
      <span id={`${name}-caption`} className={captionClassNames} data-testid="halo-caption">
        {error}
      </span>
    </div>
  );
};
